/**
 * BriqueChart의 X축 관련 기능 구현
 */

// import BriqueChart from './BriqueChart.vue'
import EventHandler from './EventHandler.js'
import BriqueChart from './BriqueChart.vue'

export default {
  /**
   * X축에서 우 클릭시 표시할 Context Menu 리스트를 구한다.
   * @param {Object}} chartVue Chart Vue 객체
   * @returns X축의 Context Menu 리스트
   */
  getXAxisContextMenu: (chartVue) => {
    return {
      visible: false,
      selectedSeriesName: '',
      list: [
        { label: chartVue.$t('fdc.CHART_COMPONENT.LABEL.SELECT_X_DATA'),
          visible: true,
          disabled: false,
          click: () => {
            let element = chartVue.$el.children[0]
            BriqueChart.openChartModal(element, 'xAxisDataSelection')
          }
        }
      ]
    }
  },

  /**
   * X축의 우 클릭과 관련한 초기화
   * @param {Object} element Chart Element
   */
  initXAxis (element) {
    let dragLayer = element.querySelector(`.main-svg .draglayer`)
    EventHandler.removeAndAddEventListener(dragLayer, `contextmenu.${element.id}_xaxis`, function (e) {
      if (!EventHandler.matches.call(e.target, '.xy .wdrag,.edrag,.ewdrag')) return

      // visible한 메뉴가 하나도 없으면 메뉴 자체가 안보이게
      if (!element.parentElement.__vue__.xAxisContextMenu.list.some((item) => typeof (item.visible) === 'function' ? item.visible() : item.visible)) {
        return
      }

      element.parentElement.__vue__.xAxisContextMenu.visible = true
      setTimeout(() => {
        let xMenu = document.querySelector(`#xaxis_contextmenu_${element.id}`)

        let x = (e.clientX + xMenu.clientWidth) > document.body.clientWidth ? (e.clientX - xMenu.clientWidth) : e.clientX
        let y = (e.clientY + xMenu.clientHeight) > document.body.clientHeight ? (e.clientY - xMenu.clientHeight) : e.clientY

        xMenu.style.left = `${x}px`
        xMenu.style.top = `${y}px`
      })

      e.stopPropagation()
      e.preventDefault()

      return false
    })

    EventHandler.removeAndAddEventListener(document.body, `click.${element.id}_xaxis_contextmenu`, function (e) {
      // chart split 해제 후 없어진 element이면
      if (_.isEmpty(document.getElementById(element.id))) {
        EventHandler.removeEventListener(document.body, `click.${element.id}_xaxis_contextmenu`)
        return
      }

      if (element.parentElement.__vue__.xAxisContextMenu.visible !== true) {
        return
      }

      element.parentElement.__vue__.xAxisContextMenu.visible = false
    })
  }
}
